<template>
    <div class="logs_order">
        <div class="d-flex flex-row align-items-center" v-for="log in this.logs">
            <div class="mt-2 w-100">
                <div id="panel-3" class="panel  mt-1 panel-collapsed mb-0" >
                    <div class="panel-hdr color-success-600 p-2 cursor-pointer"  data-action="panel-collapse" data-toggle="tooltip">

                        <div class="icon-stack display-3 flex-shrink-0 mr-2 d-none d-sm-block">
                            <i class="fal fa-circle icon-stack-3x opacity-100 "  :class="[(is_ok_state(log)) ? 'color-success-400':'color-danger-400']"></i>
                            <i class="fas fa-address-book icon-stack-1x opacity-100 " :class="[(is_ok_state(log)) ? 'color-success-500':'color-danger-500']"></i>
                        </div>

                        <h2>
                            {{ log.action_type }}
                            <sup class="log_info">
                                <span class="badge  ml-2" :class="[(is_ok_state(log)) ? 'badge-success':'badge-danger']">
                                    {{log.status}}
                                </span>
                            </sup>
                            <span class="fw-300"><i></i></span>
                        </h2>

                        <div class="panel-toolbar">
                            <div class="mr-1  color-black">
                                {{ log.added }}
                            </div>
                        </div>
                    </div>

                    <div class="panel-container collapse" style="width: 100%" :class="[log.show_resp ? 'sho' : '']">
                        <div class="panel-content">
                            <div v-if="log.hasOwnProperty('show_order_ext') && log.show_order_ext">
                                <div class="subheader mb-0">
                                    <h1 class="subheader-title">
                                        <i class="subheader-icon fal fa-window"></i> SUMMARY
                                    </h1>
                                </div>

                                <div v-if="!log.is_html">
                                    <pre style=" word-break: break-all; max-height: 350px;overflow: auto">{{log.order_ext}}</pre>
                                </div>
                            </div>

                            <div class="subheader mb-2 pb-2">
                                <h1 class="subheader-title">
                                    <i class="subheader-icon fal fa-window"></i> SRV_RESPONSE
                                </h1>
                                <div class="flex_in cursor-pointer" v-on:click="copy(JSON.stringify(log.action_data).trim())">
                                    <i class="fal fa-copy fs-xxl"></i>
                                </div>
                            </div>
                            <div>
                                <pre style=" word-break: break-all; max-height: 350px;overflow: auto">{{ JSON.stringify(log.action_data, null, 2).trim() }}</pre>
                            </div>

                            <div >
                                <div class="subheader mb-2 pb-2">
                                    <h1 class="subheader-title">
                                        <i class="subheader-icon fal fa-window"></i> PAYLOAD
                                    </h1>

                                    <div class="flex_in cursor-pointer" v-on:click="copy(JSON.stringify(log.payload).trim())" ref="container">
                                        <i class="fal fa-copy fs-xxl"></i>
                                    </div>

                                </div>
                                <div>
                                    <pre style=" word-break: break-all; max-height: 350px;overflow: auto">{{ JSON.stringify(log.payload, null, 2).trim() }}</pre>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div ref="message" ></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "order_logs",
    props: {
        logs: {
            type: Array
        },
        cur_provider : {
            type : String
        }
    },
    methods : {
        is_ok_state(log) {
            return log.status === 'operation_success' || log.status === 'operation_done';
        },

        is_provider_response() {

        },

        copy(obj) {
            this.$copyText(obj,this.$refs.container[0]).then(function (e) {
                console.log("COPY_OK",e)
            }, function (e) {
                console.log("ERR_COPY",e)
            })
        }
    },
}
</script>

<style scoped>

</style>
